import styles from './Logo.module.css';
import { HuelwearLogo } from './HuelwearLogo/HuelwearLogo';
import { JapanLogo } from './JapanLogo/JapanLogo';
import { BaseLogo } from './PrimaryLogo/PrimaryLogo';

interface LogoProps {
  logoType?: 'primary' | 'huelwear' | 'japan';
}

export const Logo = ({ logoType = 'primary' }: LogoProps) => {
  const renderLogo = () => {
    switch (logoType) {
      case 'japan':
        return <JapanLogo />;
      case 'huelwear':
        return <HuelwearLogo />;
      default:
        return <BaseLogo />;
    }
  };

  return (
    <div className={styles.Logo}>
      <div className={styles.Logo__inner}>{renderLogo()}</div>
    </div>
  );
};
